import React from 'react';

import { useTranslation } from 'react-i18next';

import { ButtonDeprecated, YatTile } from '@pkg/components';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { type EmojiId } from '@app/client';
import { setNftPanelOpen } from '@app/store/actions/nft';
import { addNotification } from '@app/store/actions/notification';

import { Typography } from '../../../DesignSystem';
import '../NftSidePanel.scss';

interface InitiateTransferProps {
    currentEmoji: EmojiId;
    currentRhythmScore: number;
}
export const YatNotVisualized = ({ currentEmoji, currentRhythmScore }: InitiateTransferProps) => {
    const { t } = useTranslation(['nft', 'common']);
    const { visualizerUrl } = useAppSelector((state) => state.userEmojis);
    const dispatch = useAppDispatch();

    const onClickOpenVisualizer = () => {
        if (visualizerUrl) {
            window.location.href = visualizerUrl;
            return;
        } else {
            // Visualizer URL not available, send error feedback
            dispatch(addNotification({ message: t('common:error_generic'), severity: 'error' }));
        }
        dispatch(setNftPanelOpen(false));
    };

    return (
        <div className="yat-nft-sidebar__step yat-nft__not-visualized">
            <div className="yat-nft-sidebar__flex-item">
                <YatTile
                    forceSprite={true}
                    yat={currentEmoji}
                    rhythmScore={currentRhythmScore}
                    showRhythmScore={false}
                    glow={true}
                    classes={'yat-nft-sidebar__yat yat-nft-sidebar__yat-not-visualized'}
                />
                <Typography type="headline" size={40} classes={['nft-sidebar-title-desktop']}>
                    {t('mint_yat_not_visualized_title')}
                </Typography>
                <Typography type="paragraph" size={16} classes={['nft-sidebar-text-desktop']}>
                    {t('mint_yat_not_visualized_text')}
                </Typography>
                <ButtonDeprecated
                    color="primary"
                    size="hero"
                    classes={['nft-sidebar-cta-desktop']}
                    onClick={onClickOpenVisualizer}
                >
                    {t('mint_yat_not_visualized_cta')}
                </ButtonDeprecated>
                <ButtonDeprecated
                    color="primary"
                    size="large"
                    classes={['nft-sidebar-cta-mobile']}
                    onClick={onClickOpenVisualizer}
                >
                    {t('mint_yat_not_visualized_cta')}
                </ButtonDeprecated>
            </div>
        </div>
    );
};
